/* eslint-disable */
import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import moment from 'moment';
var Datetime = require('react-datetime');
import CadastrarProtocoloForm from './CadastrarProtocoloForm'
import ConfigD from './util/ConfigD';
import Helpers from './util/Helpers'
import './css/loginForm.css'
import './css/step.css'
import 'jquery-validation';
import $ from 'jquery';


//https://stackoverflow.com/questions/22002626/does-bootstrap-3-have-a-pre-built-steps-option-for-forms
//https://github.com/react-component/slider
//http://react-component.github.io/slider/examples/handle.html

//https://github.com/ritz078/react-slider

//https://github.com/whoisandy/react-rangeslider
//https://whoisandy.github.io/react-rangeslider/
//
class CadastrarProtocolo extends React.Component {
 
    constructor(props, context) {
        super(props, context);
        //debugger;
        this.state = {
            natureza: !$.isEmptyObject(this.props.params) && this.props.params.natureza ? this.props.params.natureza : 'geral',
            uf: !$.isEmptyObject(this.props.params) && this.props.params.uf ? this.props.params.uf : '',
            canal: !$.isEmptyObject(this.props.params) && this.props.params.canal ? this.props.params.canal : 'intranet',
            grupoTratamento: !$.isEmptyObject(this.props.params) && this.props.params.grupo ? this.props.params.grupo : 'ouvidoria'

        };

    }


    componentWillReceiveProps(nextProps) {

        //debugger;
        //if(!$.isEmptyObject(nextProps.clienteLogado)){
           //debugger;
            //enviar para página de oses desse cliente com a situação delas. 
            //this.context.router.push('/servico');
        //}
      
    }

    render() {
        //console.log('servicos', this.props.servicos);
        // if($.isEmptyObject(this.props.servicos)){
        //   return <div/>
        // }
        //console.log('natureza ' , this.state.natureza)

        //UPP: o react-router reaproveita a instância do form entre rotas do mesmo componente (ex.: '/' -> '/cadastrarProtocolo/upp/...').
        //A key força a remontagem ao entrar/sair do canal 'upp', para o componentDidMount reaplicar UF, natureza e navegação.
        var chaveForm = !$.isEmptyObject(this.props.params) && this.props.params.canal && this.props.params.canal.toLowerCase() === 'upp' ? 'upp' : 'padrao';

    return (
        
        <div>
            <div className="breadcrumb-wrapper">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-xs-12 col-sm-6">
                        <h2 className="title">{this.state.natureza=== 'geral'?'Cadastrar manifestação': 'Cadastrar denúncia'}</h2>
                        </div>
                        <div className="col-lg-6 col-md-6 col-xs-12 col-sm-6">
                            <div className="breadcrumbs pull-right">
                                <ul>
                                    <li>Você está aqui:</li>
                                    <li><a href={ConfigD.getServerBase() === '' ? '/' : ConfigD.getServerBase()}>Home</a></li>
                                    <li>{this.state.tituloPagina}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <div className="container">
                <div className="row">
                    <div className='row'>
                        <CadastrarProtocoloForm key={chaveForm} {...this.props} />
                    </div>
                </div>
            </div>
        </div>
    );
  }
}

CadastrarProtocolo.protoType = {
    actionCliente: PropTypes.object.isRequired
}
CadastrarProtocolo.contextTypes = {
  router: React.PropTypes.object
};

function mapStateToProps(state, ownProps){
    //debugger;
    return {
            //clienteLogado: state.cliente

    };
}

function mapDispatchToProps(dispatch){
   return {
        
        //actionCliente: bindActionCreators(clienteActions, dispatch)
    };
    
}

export default connect(mapStateToProps, mapDispatchToProps)(CadastrarProtocolo);



/** WEBPACK FOOTER **
 ** ./src/components/CadastrarProtocolo.js
 **/